import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './auth.slice';
import { alertReducer } from './alert.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
  },
});

